export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7188.e4439ddd.jpg";